import { assign, find, map } from 'lodash';
import ModuleStore from '../store/moduleStore';
import RoutePath from '../constants/routePath';
const EventEmitter = require('events').EventEmitter;
var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var Router = require('react-router').Router;
var history = require('react-router').browserHistory;

var RaRouteWrapper = require('../routes/raRouteWrapper'),
  AdminRouteWrapper = require('../routes/adminRouteWrapper');

var CHANGE_EVENT = 'change';
var _items = [];
var _activeItem = undefined;

var moduleCodes = require('constants/moduleCodes');
var menuUrlsMapAdmin = require('admin/menuUrlsMap');
var menuUrlsMapRA = require('modules/ra/menuUrlsMap');
var menuUrlsMapInspectionCoach = require('modules/inspectionCoach/menuUrlsMap');
var menuUrlsMapInspectionCentre = require('modules/inspectionCentre/menuUrlsMap');
var menuUrlsMap2Bap = require('modules/2bap/2bap/menuUrlsMap');

var getUrlsInspectionCentre = require('modules/inspectionCentre/getUrls').default;
var inspectionCentreRouteKeys = require('modules/inspectionCentre/constants/menuRouteKeys').default;

var MenuStore = assign({}, EventEmitter.prototype, {
  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function () {
    this.emit(CHANGE_EVENT);
  },

  getAllItems: function () {
    return _items;
  },

  getItemById: function (id) {
    return find(_items, {id: id});
  },

  setInitialItem: function (items) {
    items.forEach(function (item) {
      if (item.isActive) {
        _activeItem = item;
      }
    }.bind(this))
  },

  normalize: function (items) {
    return map(items, function (item) {
      item.isActive = _activeItem
        ? item.routeWithModule == _activeItem.routeWithModule
        : (item.routeWithModule == RaRouteWrapper.getHome()
          || item.routeWithModule == AdminRouteWrapper.getOrganisations()
          || item.routeWithModule == RaRouteWrapper.getRa()
          || item.routeWithModule == AdminRouteWrapper.getAdmin());
      return item;
    })
  },

  updateRoutes: function (itemList, module) {
    var self = this;
    return map(itemList, function (item) {
      if (item.route) {
        if (module === moduleCodes.MODULE_ADMIN) {
          item.routeWithModule = menuUrlsMapAdmin[item.route];
        }
        if (module === moduleCodes.MODULE_RA) {
          item.routeWithModule = menuUrlsMapRA[item.route];
        }
        if (module === moduleCodes.MODULE_INSPECTION_COACH) {
          item.routeWithModule = menuUrlsMapInspectionCoach[item.route];
        }
        if (module === moduleCodes.MODULE_INSPECTION_CENTRE) {
          item.routeWithModule = menuUrlsMapInspectionCentre[item.route];
        }
        if (module === moduleCodes.MODULE_2BAP) {
          item.routeWithModule = menuUrlsMap2Bap[item.route]
        }
      }
      if (item.childActions) {
        item.childActions = self.updateRoutes(item.childActions, module);
      }
      return item;
    })
  },

  createMenuObject(data, getUrlFunc, withPartialRoute) {
    return {
      id: data.id || data.name,
      isExternal: false,
      isToWeb: false,
      routeWithModule: getUrlFunc(data.id),
      partialRouteMatch: withPartialRoute ? getUrlFunc(data.id) : null,
      title: data.name,
      tooltip: data.name
    }
  },

  insertChildToItem(items, targetRoute, getChildUrl, childrenObjects, includePartialRoute = false) {
    var childItems = map(childrenObjects, (childrenObject) => this.createMenuObject(childrenObject, getChildUrl, includePartialRoute));

    return map(items, function (item) {
      if (item.route === targetRoute) {
        item.childActions = childItems;
      }
      return item;
    });
  },

  isMenuOpenByDefault(menuItem) {
    const currentModule = ModuleStore.getCurrentModule();
    if (!currentModule) {
      return false;
    }

    const improvementHubTasks = currentModule.code === moduleCodes.MODULE_INSPECTION_CENTRE &&
      menuItem.route === RoutePath.ROUTE_INSPECTION_TASKS;

    const administrationModules = currentModule.code === moduleCodes.MODULE_ADMIN &&
      menuItem.route === RoutePath.ROUTE_ADMIN_MODULES;

    const administrationModulesReadingAssessment = currentModule.code === moduleCodes.MODULE_ADMIN &&
      menuItem.route === RoutePath.ROUTE_ADMIN_MODULES_READING_ASSESSMENT;

    const administrationModulesOfsted = currentModule.code === moduleCodes.MODULE_ADMIN &&
      menuItem.route === RoutePath.ROUTE_ADMIN_MODULES_OFSTED;

    const administrationModulesEvidenceMe = currentModule.code === moduleCodes.MODULE_ADMIN &&
      menuItem.route === RoutePath.ROUTE_ADMIN_MODULES_EVIDENCE_ME;

    return improvementHubTasks ||
      administrationModules ||
      administrationModulesReadingAssessment ||
      administrationModulesOfsted ||
      administrationModulesEvidenceMe;
  }
});

Dispatcher.register(function (action) {
  switch (action.actionType) {
    case ActionType.MENU_INITIALIZE:
      _activeItem = undefined;
      _items = MenuStore.updateRoutes(action.initialData.menu, action.initialData.module);
      _items = MenuStore.normalize(_items);
      MenuStore.setInitialItem(_items);
      MenuStore.emitChange();
      break;
    case ActionType.MENU_GET_MENU:
      _activeItem = undefined;
      _items = MenuStore.updateRoutes(action.menu, action.module);
      _items = MenuStore.normalize(_items);
      MenuStore.setInitialItem(_items);
      MenuStore.emitChange();
      break;
    case ActionType.MENU_ACTIVATE_ITEM:
      _activeItem = action.item;
      _items = MenuStore.normalize(_items);
      if (_activeItem.routeWithModule) {
        history.push(_activeItem.routeWithModule)
      }
      MenuStore.emitChange();
      break;
    case ActionType.MENU_INSPECTION_CENTRE_GET_FILTERS:
      action.payload.unshift(
        {name: "All Actions"}
      );
      _items = MenuStore.insertChildToItem(_items, inspectionCentreRouteKeys.tasks, getUrlsInspectionCentre.getTasksFilterUrl,
        action.payload, true);
      MenuStore.emitChange();
      break;
    default:
    //no op
  }

});

module.exports = MenuStore;
